// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgSearchEnergy = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M13.714 3.93a6.857 6.857 0 1 1-9.69 9.705 6.857 6.857 0 0 1 9.69-9.706z"
    />
    <path
      fill="currentColor"
      d="m11.537 8.578-3.429 4.457c-.133.216-.216.196-.181-.04l.47-3.717h-1.76c-.233 0-.315-.172-.181-.384l3.428-4.457c.13-.213.213-.196.179.044l-.463 3.7h1.769c.23-.004.312.171.168.397z"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m22.056 19.967-2.181 2.182-5.502-5.5 2.182-2.182zM13.715 13.615l1.844 1.844"
    />
  </svg>
);
export default SvgSearchEnergy;
